import GenericSlider from "../components/GenericSlider";
import TabSlider from "../components/TabSlider";

export default {
  init() {
    new TabSlider(".tab-slider");
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};
